import styled from "styled-components";

export const Wrapper = styled.div`
    text-align: right;
    font-family: monospace;
    color: #777;
    font-size: 14px;
    margin-bottom: 20px;
`;